import styled from '@emotion/styled';
import { menuStyle as bigMenuStyle } from './LaunchpadDropdownStyle';

const _buttonTopPadding = 9;
const _fontSize = 12;
const _itemHeight = 22;
const _itemStartPad = 16;

export const menuStyle = {
  ...bigMenuStyle,

  itemHeight: _itemHeight,

  MenuButtonLabel: styled(bigMenuStyle.MenuButtonLabel)((props) => {
    let style = {
      top: _buttonTopPadding - 0.5,
      fontSize: _fontSize,
      lineHeight: _fontSize * 1.25 + 'px'
    };
    return style;
  }),

  MenuButtonArrow: styled(bigMenuStyle.MenuButtonArrow)((props) => {
    let style = {
      top: _buttonTopPadding - 1
    };
    return style;
  }),

  MenuItem: styled(bigMenuStyle.MenuItem)((props) => {
    let style = {
      fontSize: _fontSize,
      height: _itemHeight
    };
    if (props.isRtl) {
      style.paddingRight = _itemStartPad;
    } else {
      style.paddingLeft = _itemStartPad;
    }

    return style;
  })
};



// WEBPACK FOOTER //
// ./src/styles/LaunchpadCompactDropdownStyle.js